<template>
  <!-- 会员投注 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="会员账号">
          <a-input v-model="userid" />
        </a-form-item>
        <a-form-item>
          <a-select style="width: 290px" v-model="defaultTermsetdata">
            <a-select-option v-for="item in termsetdata" :key="item.ID">
              {{ item.Tname }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search()">搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-tooltip placement="topLeft" title="请输入完整账号,无法允许馍糊查询!" arrow-point-at-center>
            <a-button type="primary" @click="searchuser()">单会员全搜索</a-button>
          </a-tooltip>
        </a-form-item>
        <a-form-item v-if="role249">
          <a-button type="primary" @click="allExport()">导出全部</a-button>
        </a-form-item>
        <a-form-item v-if="role249">
          <a-button type="primary" @click="payoutExport()">导出派彩</a-button>
        </a-form-item>
        <br />
        <a-form-item v-if="role250">
          <a-button type="danger" @click="checkDelete()">勾选删除</a-button>
        </a-form-item>
        <a-form-item v-if="role251">
          <a-button type="danger" @click="termDelete()">删除本期</a-button>
        </a-form-item>
        <a-form-item v-if="role252">
          <a-button type="primary" class="marr10" @click="anewTotal(4)">继续计算</a-button>
          <span class="red">继续计算,将会对"本期"以及"之后"的期别进行重新计算</span>
        </a-form-item>
        <a-form-item label="修改备注">
          <a-input placeholder="输入要批量修改备注内容" maxlenght="100" v-model="editmemo" />
        </a-form-item>
        <a-button type="primary" class="marr10" @click="batcheditmemo()">批量修改备注</a-button>
        <a-button type="primary" class="marr10" @click="add()">{{ buttonText }}</a-button>
      </a-form>
    </div>
    <br />
    <a-table size="middle" :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }" :columns="columns" row-key="UserID" :data-source="data" :pagination="false" :loading="loading" bordered>
      <template slot="CalState" slot-scope="text">
        <font v-if="text === 1" color="red">未计算</font>
        <font v-if="text === 2" color="green">计算中</font>
        <font v-if="text === 3" color="blue">完成</font>
      </template>
      <template slot="operate" slot-scope="text, record">
        <template slot="title"> 编辑 </template>
        <a href="javascript:;" @click="onEdit(record)">
          <a-icon type="edit" style="font-size: 22px"></a-icon>
        </a>
      </template>
    </a-table>
    <div style="margin: 16px 0; height: 8px">
      <a-pagination style="float: right" show-size-changer :default-current="pagination.current"
        :total="pagination.total" :show-total="(total) => `共 ${total} 条`" :pageSizeOptions="pagination.sizeList"
        @change="pageNumberChange" @showSizeChange="sizeChange" />
    </div>

    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="编辑" @ok="modalOk">
      <a-form-model :model="formModel" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="期别排序">
          <a-input v-model="formModel.TermIndex" placeholder="期别排序" read-only />
        </a-form-model-item>
        <a-form-model-item label="会员帐号">
          <a-input v-model="formModel.UserID" placeholder="会员帐号" read-only />
        </a-form-model-item>
        <a-form-model-item label="备注">
          <a-textarea v-model="formModel.Memo" :auto-size="{ minRows: 4, maxRows: 7 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <a-modal v-model="visibleAdd" title="编辑" @ok="modalAddOk">
      <a-form-model ref="ruleForm" :model="formAdd" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="会员账号" ref="UserID" prop="UserID">
          <a-input v-model="formAdd.UserID" placeholder="会员账号" :read-only="isreadonly" />
        </a-form-model-item>
        <a-form-model-item label="存款金额" ref="Amount" prop="Amount">
          <a-input v-model.number="formAdd.Amount" placeholder="存款金额" />
        </a-form-model-item>
        <span class="red">※新增会员如原先已于名单内，原先数据将被覆盖以此页面数据为主</span>
      </a-form-model>
    </a-modal>
  </a-layout-content>
</template>
<script>
  import moment from "moment";
  import lodash from 'lodash';
  export default {
    data() {
      return {
        /*** 权限
          248	存款查询
          249	存款导出
          250	存款批量删除
          251	删除本期
          252	从头计算
         */
        role248: false,
        role249: false,
        role250: false,
        role251: false,
        role252: false,
        type: 3,
        data: [],
        columns: [
          {
            title: "期别排序",
            dataIndex: "TermIndex",
            align: "center",
          },
          {
            title: "会员帐号",
            dataIndex: "UserID",
            align: "center",
          },
          {
            title: "UVIP",
            dataIndex: "Level",
            align: "center",
          },
          {
            title: "U存款金额",
            dataIndex: "BetTotal",
            align: "center",
          },
          {
            title: "晋级礼金",
            dataIndex: "UpBonus",
            align: "center",
          },
          {
            title: "周俸禄",
            dataIndex: "WeekBonus",
            align: "center",
          },
          {
            title: "月俸禄",
            dataIndex: "MonthBonus",
            align: "center",
          },
          {
            title: "备注",
            dataIndex: "Memo",
            align: "center",
          },
          {
            title: "操作",
            dataIndex: "operate",
            align: "center",
            scopedSlots: { customRender: "operate" },
          },
        ],
        termsetdata: undefined,
        defaultTermsetdata: undefined,
        userid: undefined,
        editmemo: "",
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0,
          sizeList: ["10", "50", "500", "5000", "10000"],
        },
        selectedRowKeys: [],
        selectedRows: [],
        loading: false,
        labelCol: { span: 5 },
        wrapperCol: { span: 14 },
        visible: false, //弹框状态
        formModel: {}, // 弹框字段
        visibleAdd: false, //弹框状态
        formAdd: {}, // 弹框字段
        isreadonly: false,
      };
    },
    computed: {
      buttonText() {
        if (this.selectedRowKeys.length > 0) {
          return '编辑会员存款';
        } else {
          return '新增会员存款';
        }
      }
    },
    methods: {
      moment,
      //分页页数的改变
      pageNumberChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.qryListAPI();
      },
      //  分页显示条数的变化
      sizeChange(current, size) {
        this.pagination.current = current;
        this.pagination.pageSize = size;
        this.qryListAPI();
      },
      // 搜索
      search() {
        this.pagination.current = 1;
        this.qryListAPI();
      },
      // 导出全部
      allExport() {
        const that = this;
        this.$confirm({
          title: "导出",
          content: "确定要导出本期全部数据吗？",
          onOk() {
            that.exportData(0);
          },
        });
      },
      // 导出派彩
      payoutExport() {
        const that = this;
        this.$confirm({
          title: "导出",
          content: "确定要导出本期包含有彩金的数据吗？",
          onOk() {
            that.exportData(1);
          },
        });
      },
      //导出
      exportData(viptype) {
        let today = new Date();
        this.$message.success(
          "开始执行导出请在停留在页面勿离开,因数据量较多请稍待片刻谢谢"
        );
        this.axios({
          url: "/userbet/exportuserbet",
          method: "get",
          params: {
            UserID: this.userid == undefined ? "" : this.userid,
            TermID: this.defaultTermsetdata,
            Type: 3,
            Level: viptype,
          },
          responseType: "blob",
        }).then((response) => {
          let blob = new Blob([response.data], { type: response.data.type });
          // 针对于 IE 浏览器的处理, 因部分 IE 浏览器不支持 createObjectURL
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // 创建下载的链接
            downloadElement.href = href;
            downloadElement.download =
              "USDT会员存款- " + today.toISOString().split("T")[0]; // 下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); // 点击下载
            document.body.removeChild(downloadElement); // 下载完成移除元素
            window.URL.revokeObjectURL(href); // 释放掉 blob 对象
          }
        });
      },
      // 勾选删除
      checkDelete() {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        const that = this;
        this.$confirm({
          title: "批量删除",
          content:
            "您要确定要删除勾选数据吗?温馨提示:此删除只会联动会员存款数据部份,会员统计数据需要至统计重新计算!",
          onOk() {
            const idList = [];
            that.selectedRowKeys.forEach((element) => {
              idList.push({ UserID: element, Amount: 0 });
            });
            that.axios
              .post("/userbet/deleteuserbet", {
                Type: 3,
                TermID: that.defaultTermsetdata,
                UserList: idList,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("删除成功");
                  that.qryListAPI();
                }
              });
          },
        });
      },
      //批量修改备注
      batcheditmemo() {
        if (this.selectedRowKeys.length < 1) {
          this.$message.warning("请勾选数据");
          return;
        }
        const that = this;
        this.$confirm({
          title: "批量修改备注",
          content:
            "您要确定要批量修改备注吗?注意!如果未填写备注送出会也会将选到的清除备注!",
          onOk() {
            const idList = [];
            that.selectedRowKeys.forEach((element) => {
              idList.push({ UserID: element, Amount: 0 });
            });
            that.axios
              .post("/userbet/userbetbatcheditmemo", {
                Type: 3,
                TermID: that.defaultTermsetdata,
                UserList: idList,
                Memo: that.editmemo,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("批量修改成功");
                  that.qryListAPI();
                }
              });
          },
        });
      },
      // 删除本期
      termDelete() {
        const that = this;
        this.$confirm({
          title: "删除本期",
          content:
            "您确定要删除本期数据吗？温馨提示:此删除只会联动会员存款数据部份,会员统计数据需要至统计重新计算!",
          onOk() {
            that.axios
              .post("/userbet/termdeleteuserbet", {
                Type: 3,
                TermID: that.defaultTermsetdata,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success("本期数据删除成功");
                  that.qryListAPI();
                }
              });
          },
        });
      },
      // 从头计算
      anewTotal(caltype) {
        let msg = "继续计算";

        const that = this;
        this.$confirm({
          title: msg,
          content: "您确定" + msg + "？",
          onOk() {
            that.axios
              .post("/userbet/caluserbet", {
                Type: 3,
                CalType: caltype,
                TermID: that.defaultTermsetdata,
              })
              .then((res) => {
                if (res.data) {
                  that.$message.success(
                    "已提交服务计算,可至会员计算进度列表查询"
                  );
                  that.qryListAPI();
                }
              });
          },
        });
      },
      // 查询API
      qryListAPI() {
        this.loading = true;
        this.axios
          .post("/userbet/getuserbet", {
            UserID: this.userid == undefined ? "" : this.userid,
            TermID: this.defaultTermsetdata,
            Type: 3,
            pageindex: this.pagination.current,
            pagesize: this.pagination.pageSize,
          })
          .then((res) => {
            if (res.data) {
              this.pagination.total = res.total;
              this.loading = false;
              this.data = res.data;
            }
          });
      },
      searchuser() {
        if (this.userid == undefined || this.userid == "") {
          this.$message.warning("会员账号不能得为空");
          return;
        }

        this.pagination.current = 1;
        this.loading = true;
        this.axios
          .post("/userbet/getuserbet", {
            UserID: this.userid == undefined ? "" : this.userid,
            TermID: 0,
            Type: this.type,
            pageindex: this.pagination.current,
            pagesize: this.pagination.pageSize,
          })
          .then((res) => {
            if (res.data) {
              this.pagination.total = res.total;
              this.loading = false;
              this.data = res.data;
            }
          });
      },
      onSelectChange(selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectedRows = selectedRows;
      },
      // 查询周期
      qrytermset() {
        this.axios.post("/rank/gettermset", { Type: 3 }).then((res) => {
          if (res.data) {
            this.termsetdata = res.data;
            this.defaultTermsetdata = res.data[0].ID;
            this.qryListAPI();
          }
        });
      },
      //编辑弹框
      onEdit(data) {
        this.visible = true;
        this.formModel = {};
        this.formModel.UserID = data.UserID;
        this.formModel.TermIndex = data.TermIndex;
        this.formModel.TermID = data.TermID;
        this.formModel.Level = 3;
        this.formModel.Memo = data.Memo;
      },
      modalOk() {
        // 弹框确认动作
        this.axios.post("/UserBet/SaveUserBetMemo", this.formModel).then((res) => {
          if (res.data) {
            this.$message.success("编辑成功");
            this.qryListAPI();
            this.visible = false;
          }
        });
      },
      add() {
        if (this.selectedRows.length === 0) {
          this.formAdd = {};
          this.isreadonly = false;
        }
        else if (this.selectedRows.length === 1) {
          let editrows = lodash.cloneDeep(this.selectedRows[0]);
          this.formAdd.UserID = editrows.UserID;
          this.formAdd.Amount = editrows.BetTotal;
          this.isreadonly = true;
        }
        else {
          this.$message.warning("只能勾选编辑1位会员");
          return;
        }
        this.visibleAdd = true;
      },
      //对话框确认按钮
      modalAddOk() {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            const that = this;
            this.$confirm({
              title: this.buttonText,
              content: this.buttonText + "后必须从该期别继续计算数据才会显示",
              onOk() {
                const recordList = [];
                recordList.push(that.formAdd);

                that.axios.post("/userbet/importuserrecord", {
                  TermID: that.defaultTermsetdata,
                  Type: that.type,
                  RecordList: recordList,
                }).then((res) => {
                  if (res.data) {
                    const mes = that.buttonText + "成功";
                    that.$message.success(mes);
                    that.qryListAPI();
                    that.visibleAdd = false;
                  }
                });
              },
            });
          }
        });
      },
    },
    //首次加载
    created() {
      this.qrytermset();
      //获取权限
      const array = JSON.parse(sessionStorage.RoleID);
      const roleID = [248, 249, 250, 251, 252, 253];
      var isRole = roleID.filter(function (item) {
        return array.indexOf(item) != -1;
      });
      //功能权限获取
      isRole.forEach((element) => {
        this["role" + element] = true;
      });
    },
  };
</script>

<style>
  .red {
    color: rgb(255, 0, 0);
  }

  .marr10 {
    margin-right: 10px;
    background-color: green;
  }
</style>


// WEBPACK FOOTER //
// src/components/usdtleaderboard/userbet.vue